export default __webpack_public_path__ + "static/media/wave-2.80879742.png";